module.exports = {
      id: "turkey-usage",
      viewBox: "0 0 24 17",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#turkey-usage",
      toString: function () {
        return this.url;
      }
    }